import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import {
  ArrowRight,
  FileText,
  Heart,
  LogOutIcon,
  LucideIcon,
  PawPrintIcon,
  UserIcon,
} from 'lucide-react';

import { NbButton, NbPageHeader } from '@/components/Neobrut';
import { useAuthToken } from '@/hooks/useAuthToken';

type Row = {
  label: string;
  path: string;
  icon: LucideIcon;
  fill: string;
};

const ROWS: Row[] = [
  { label: 'Mis datos', path: '/my-profile', icon: UserIcon, fill: 'fill-paper' },
  { label: 'Mis publicaciones', path: '/my-publications', icon: FileText, fill: 'fill-lost' },
  { label: 'Mis mascotas', path: '/my-pets', icon: PawPrintIcon, fill: 'fill-urgent' },
  { label: 'Favoritos', path: '/my-favorites', icon: Heart, fill: 'fill-found' },
];

export const MyAccount = () => {
  const { token, isTokenExpired, clearToken } = useAuthToken();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || isTokenExpired(token)) navigate('/login');
  });

  return (
    <div className="mx-auto w-full max-w-md pb-10">
      <NbPageHeader
        slug="/ mi cuenta"
        title={
          <>
            Tu espacio,
            <br />
            <span className="nb-highlight">acá.</span>
          </>
        }
        tone="plain"
      />
      <div className="flex flex-col gap-2 px-4 pt-4">
        {ROWS.map((row) => {
          const Icon = row.icon;
          return (
            <button
              key={row.path}
              onClick={() => navigate(row.path)}
              className={`nb flex items-center gap-2.5 px-2.5 py-2.5 text-left ${row.fill}`}
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center">
                <Icon size={20} />
              </span>
              <span className="font-display flex-1 text-[18px] leading-none">{row.label}</span>
              <ArrowRight size={14} />
            </button>
          );
        })}
      </div>

      <div className="mt-6 px-4">
        <NbButton fill="urgent" className="w-full py-3" onClick={clearToken}>
          <LogOutIcon size={16} /> Cerrar sesión
        </NbButton>
      </div>
    </div>
  );
};
